import actualite1 from '../../images/actualite/actualite-1.jpg';
import actualite2 from '../../images/actualite/actualite-2.jpg';
import actualite3 from '../../images/actualite/actualite-3.jpg';
import actualite4 from '../../images/actualite/actualite-4.jpg';
import actualite5 from '../../images/actualite/actualite-5.jpg';
import actualite6 from '../../images/actualite/actualite-6.jpg';

 const IMAGES_ACTUALITES = [
  actualite1,
  actualite2,
  actualite3,
  actualite4,
  actualite5,
  actualite6,
];

export default IMAGES_ACTUALITES;